import styled from 'styled-components';

export const GameViewVerticalDividerBox = styled.div`
   display: block;
   height: 100%;
   width: 1px;
   background: radial-gradient(#C4C4C4 0%, transparent 50%);
`;

export const GameViewHorizontalDividerBox = styled.div`
   display: block;
   height: 1px;
   width: 100%;
   background-color: ${props => props.theme.colors.dividerTopBorder};
   margin: 35px 0;
`;
